import { IKeyValue, ISystemCardBaseProp } from "Model/UI";
import React from "react";
import "./AccessApprovalsCard.scss";
import Utility from "common/utilities";
import { Constants } from "common/constants";
import { Card8 } from "Components2/CardTemplates/Card8/Card8";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";

export interface IAccessApprovalsCardProp extends ISystemCardBaseProp {
  accessApprovals: IAccessApprovals;
}

export function AccessApprovalsCard(props: IAccessApprovalsCardProp) {
  let keyValues: IKeyValue[] = [
    { _key: "Dates", value: `${props.accessApprovals.fromDate} to ${props.accessApprovals.toDate}`, seperator: "-" },
    { _key: "Days", value: `${Utility.calculateDays(props.accessApprovals.fromDate, props.accessApprovals.toDate)}`, seperator: "-" }
  ];
  function getCardUI() {
    return (
      <Card8
        label1={props.accessApprovals.approvalSystemId}
        label2={`${props.accessApprovals.id} - ${props.accessApprovals.title}`}
        label3={Utility.formatDate(props.accessApprovals.date, Constants.DD_MM_YY)}
        keyValue1={{ _key: "", value: "", seperator: "" }} 
        supportMulti={props.supportMulti}
        multiSelectUI={props.multiSelectUI}
        keyValues={keyValues}
        userDetails={{
          userId: props.accessApprovals.requestorID,
          userCardName: props.accessApprovals.requestor,
          userOrganization : props.accessApprovals.title
        }}
        className={Utility.mergeCssClassNames(["access-approvals-card"])}
      ></Card8>
    );
  }
  return getCardUI();
}
